import {
    TOP_LANES_REQUEST,
    TOP_LANES_SUCCESS,
    TOP_LANES_FAILURE
} from '../../actions/marketInsights/topLanesActions';

interface TopLanes {
    topLanes: any;
    isFetching: boolean;
}

const fetchTopLanesReducer = (topLanesData: TopLanes = {
    isFetching: false,
    topLanes: {}
}, action: any): TopLanes => {
    switch (action.type) {
        case TOP_LANES_REQUEST: {
            return {
                ...topLanesData,
                isFetching: true
            };
        }
        case TOP_LANES_SUCCESS: {
            return {
                ...topLanesData,
                isFetching: false,
                topLanes: action.payload
            };
        }
        case TOP_LANES_FAILURE: {
            return {
                ...topLanesData,
                isFetching: false,
                topLanes: {}
            };
        }
        default:
            return topLanesData;
    }
};

export default fetchTopLanesReducer;
